module.exports = __webpack_public_path__ + "img/twitter@2x.3e531227.png";